import { apiClient } from '../client/apiClient';

// Fetches a short-lived upload token/URL from the server required to upload a file to the storage service.
export const getUploadSecureInfo = async (queryParams: Record<string, string>) => {
  const { data, response } = await apiClient.GET('/files/get-upload-secure-info', {
    params: { query: queryParams as any }
  });
  if (!response.ok) {
    throw new Error(`Failed to get upload secure info: HTTP ${response.status}`);
  }
  return data as any; //FIXME provide return type;
};
